import React, { useEffect, useRef } from 'react';
import { CircularProgress, Modal, Typography } from '@mui/material';
import './styles.css';
import { LoadingAppProps } from '../../interfaces/props/LoadingAppProps';

const LoadingApp: React.FC<LoadingAppProps> = ({ showLoading, text }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showLoading) return;
    containerRef.current?.focus();
  }, [showLoading]);

  return (
    <Modal open={showLoading} aria-labelledby="loading-app-text">
      <div
        ref={containerRef}
        tabIndex={-1}
        className="container-loading"
        role="status"
        aria-live="polite"
      >
        <CircularProgress aria-hidden="true" />
        <Typography id="loading-app-text">{text || 'Carregando...'}</Typography>
      </div>
    </Modal>
  );
};

export default LoadingApp;
